import { Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import { SavedSearch } from '../../../../classes/saved-search';
import { Helper } from '../../../../classes/helper';
import {TranslateService} from '@ngx-translate/core';
import { ListingCategory } from '../../../../classes/enums';
import { FormGroup } from '@angular/forms';
import { SavedSearchLocationType } from '../../../../classes/enums';

@Component({
  selector: 'app-saved-search',
  templateUrl: './saved-search.component.html',
  styleUrls: ['./saved-search.component.scss']
})
export class SavedSearchComponent implements OnInit {
  SavedSearchLocationType = SavedSearchLocationType;
  private _savedSearch: SavedSearch;
  public notificationEnabledForm: FormGroup;
  enableNotificationText: string;

  @Input() set savedSearch(value: SavedSearch) {
    this._savedSearch = value
  };
  get savedSearch(): SavedSearch {
    return this._savedSearch;
  }
  @Input() enableDeleteSearch: boolean = true;
  @Input() parentComponent: SavedSearchLocationType = SavedSearchLocationType.SAVE_SEARCH;
  @Output() onDeleteSavedSearchClick: EventEmitter<SavedSearch> = new EventEmitter();
  @Output() onSavedSearchClick: EventEmitter<SavedSearch> = new EventEmitter();

  description: string;
  ListingCategory = ListingCategory;
  constructor(private _translateService: TranslateService) { }

  ngOnInit() {
    this.description = this._getSavedSearchDescription();
    this.enableNotificationText = this.parentComponent === SavedSearchLocationType.SAVE_SEARCH ?
      'my-remax.saved-searches.enable-notifications' : 'my-remax.saved-searches.enable-notifications-long';
  }

  modelChanged(newValue) {
    this.savedSearch.notificationsEnabled = newValue;
  }

  onDeleteClick($event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    this.onDeleteSavedSearchClick.emit(this.savedSearch);
  }


  private _getSavedSearchDescription(): string {
    let description = '';
    // TODO: pluralization
    const f = this.savedSearch.filters;
    description += this.savedSearch.nearby;
    if (f.baths) {
      if (f.baths.min && f.baths.max) description += this._translateService.instant('my-remax.saved-searches.min-max-baths', {x: f.baths.min});
      else if (f.baths.min) description += this._translateService.instant('my-remax.saved-searches.min-baths', {x: f.baths.min});
    }
    if (f.beds) {
      if (f.beds.min && f.beds.max) description += this._translateService.instant('my-remax.saved-searches.min-max-beds', {x: f.beds.min});
      else if (f.beds.min) description += this._translateService.instant('my-remax.saved-searches.min-beds', {x: f.beds.min});
    }
    if (f.price) {
      if (f.price.min && f.price.max) description += this._translateService.instant('my-remax.saved-searches.price-range', {x: Helper.formatPrice(f.price.min), y: Helper.formatPrice(f.price.max)});
      else if (f.price.min) description += this._translateService.instant('my-remax.saved-searches.price-min', {x: Helper.formatPrice(f.price.min)});
      else if (f.price.max) description += this._translateService.instant('my-remax.saved-searches.price-max', {x: Helper.formatPrice(f.price.max)});
    }
    if (f.size) {
      if (f.size.min && f.size.max) description += this._translateService.instant('my-remax.saved-searches.size-range', {x: Helper.formatPrice(f.size.min), y: Helper.formatPrice(f.size.max)});
      else if (f.size.min) description += this._translateService.instant('my-remax.saved-searches.size-min', {x: Helper.formatPrice(f.size.min)});
      else if (f.size.max) description += this._translateService.instant('my-remax.saved-searches.size-max', {x: Helper.formatPrice(f.size.max)});
    }
    // if (f.listingTypes) {
    //   Object.keys(f.listingTypes).forEach((key) => {
    //     description += f.listingTypes[key] ? key + ', ' : ''
    //   });
    // }

    return description;
  }

}
